import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var PriceTerms = function PriceTerms(_ref) {
  var _ref$period = _ref.period,
      period = _ref$period === void 0 ? "" : _ref$period,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? "" : _ref$separator;
  var getClassName = getClassNameFactory(PriceTerms.displayName);
  var priceTerms = separator.concat(period);
  return /*#__PURE__*/React.createElement("span", {
    className: getClassName()
  }, priceTerms);
};

PriceTerms.displayName = "PriceTerms";
export default PriceTerms;